import styled from 'styled-components'

export const PerformanceMonitorElem = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  min-width: 402px;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 100;
  border: 2px solid #333;
  box-sizing: border-box;
  padding: 20px;
  font-size: 12px;
  color: #0f1a20;
  user-select: none;
  pointer-events: none;
`

export const StatsBarElem = styled.div`
  height: 52px;
  border: 1px solid grey;
  min-width: 402px;
  transform: rotateX(180deg);
  position: relative;

  &:after {
    display: block;
    content: '';
    clear: both;
  }

  > i {
    display: block;
    width: 1px;
    font-size: 0;
    background-color: grey;
    float: right;
    margin-right: 1px;
  }
`
export const StatsTextElem = styled.div`
  padding: 5px 0 10px;

  &:last-child {
    padding-bottom: 0;
  }
`
